<div class="main-card shadow-sm">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faBox" class="text-blue" style="font-size: 14px;"></fa-icon>
      <span class="main-heading fw-smbold">Stock Movement</span>
      <span class="heading-badge fw-bold ms-1">{{ listCount | number }}</span>
    </div>
    @if (stockmovementList.length > 5) {
    <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllPurchases(purchasesModal)">
      View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
    </button>
    }
  </div>

  <!-- Highlights Top Row -->
  <div class="d-flex align-items-center gap-2 mb-2">
    <div class="highlight-card-base card-gray flex-grow-1">
      <div class="highlight-header header-gray mb-1">{{ stockHighlights.openingStock.label }}</div>
      <div class="highlight-value value-blue fw-bold">{{ stockHighlights.openingStock.value | number }} units</div>
    </div>
    <fa-icon [icon]="faArrowRight" class="arrow-icon"></fa-icon>
    <div class="highlight-card-base card-gray flex-grow-1">
      <div class="highlight-header header-gray mb-1">{{ stockHighlights.closingStock.label }}</div>
      <div class="highlight-value value-blue fw-bold">{{ stockHighlights.closingStock.value | number }} units</div>
    </div>
  </div>

  <!-- Highlights Bottom Row -->
  <div class="row g-2 mb-3">
    <div class="col-4">
      <div class="highlight-card-base card-green h-100">
        <div class="highlight-header header-green mb-1">{{ stockHighlights.stockIn.label }}</div>
        <div class="highlight-value value-green fw-bold">@if (stockHighlights.stockIn.value) {
          <span>+</span>
          }{{ stockHighlights.stockIn.value | number }} units
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="highlight-card-base card-red h-100">
        <div class="highlight-header header-red mb-1">{{ stockHighlights.stockOut.label }}</div>
        <div class="highlight-value value-red fw-bold">@if (stockHighlights.stockOut.value) {
          <span>-</span>
          }{{ stockHighlights.stockOut.value | number }} units
        </div>
        <div class="highlight-footer footer-gray mt-1">{{ stockHighlights.stockOut.subtitle }}</div>
      </div>
    </div>
    <div class="col-4">
      <div class="highlight-card-base card-gray h-100">
        <div class="highlight-header header-gray mb-1">{{ stockHighlights.netChange.label }}</div>
        <div class="highlight-value fw-bold"
          [ngClass]="(stockHighlights.netChange.value < 0) ? 'value-red' : 'value-green'">
          {{ stockHighlights.netChange.value | number }} units
        </div>
        <div class="highlight-footer footer-gray mt-1">{{ stockHighlights.netChange.subtitle }}</div>
      </div>
    </div>
  </div>

  <div class="table-box">
    <table class="table custom-table border-0 mb-0">
      <thead>
        <tr>
          <th class="fw-smbold border-0">SKUs</th>
          <th class="text-center fw-smbold border-0">Branch</th>
          <th class="text-end fw-smbold border-0">Total Inward</th>
          <th class="text-end fw-smbold border-0">Total Outward</th>
          <th class="text-end fw-smbold border-0">Closing Balance</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
        <tr>
          <td colspan="5" class="text-center py-4 border-0">
            <app-loader [loadingIcon]="loader"></app-loader>
          </td>
        </tr>
        }

        <!-- Error State -->
        @if (!loader && errMsg) {
        <tr>
          <td colspan="5" class="text-center py-4 border-0">
            <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
          </td>
        </tr>
        }

        <!-- Data State -->
        @if (!loader && !errMsg) {
        @for (item of stockmovementList | slice:0:5; track item) {
        <tr class="cursor-pointer" (click)="onRowClick(item)">
          <td class="td-col-1 border-0 text-break">{{ item.tyreMake }} {{item.tyreModel}} · {{item.tyreSize}}</td>
          <td class="td-col-1 border-0 text-center">{{item.companyName}}</td>
          <td class="text-end td-col-2 fw-smbold border-0">
            @if (item.totalInward !== null) {
            {{ item.totalInward | number }}
            } @else {
            -
            }
          </td>
          <td class="text-end td-col-2 fw-smbold border-0">
            @if (item.totalOutward !== null) {
            {{ item.totalOutward | number }}
            } @else {
            -
            }
          </td>
          <td class="text-end td-col-3 fw-bold border-0">
            @if (item.closingBalance !== null) {
            {{ item.closingBalance | number }}
            } @else {
            -
            }
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Template -->
<ng-template #purchasesModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">Stock Movement</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1" style="max-height: 60vh; overflow-y: auto;"
      infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
      [scrollWindow]="false" (scrolled)="onScroll()">
      <table class="table custom-table border-0 mb-0">
        <thead style="position: sticky; top: 0; background: white; z-index: 1;">
          <tr>
            <th class="fw-smbold border-0">SKUs</th>
            <th class="text-center fw-smbold border-0">Branch</th>
            <th class="text-end fw-smbold border-0">Total Inward</th>
            <th class="text-end fw-smbold border-0">Total Outward</th>
            <th class="text-end fw-smbold border-0">Closing Balance</th>
          </tr>
        </thead>
        <tbody>
          @if (stockmovementList.length > 0) {
          @for (item of stockmovementList; track item) {
          <tr class="cursor-pointer" (click)="onRowClick(item)">
            <td class="td-col-1 border-0 text-break">{{ item.tyreMake }} {{item.tyreModel}} · {{item.tyreSize}}</td>
            <td class="text-center td-col-1 border-0">{{item.companyName}}</td>
            <td class="text-end td-col-2 fw-smbold border-0">
              @if (item.totalInward !== null) {
              {{ item.totalInward | number }}
              } @else {
              -
              }
            </td>
            <td class="text-end td-col-2 fw-smbold border-0">
              @if (item.totalOutward !== null) {
              {{ item.totalOutward | number }}
              } @else {
              -
              }
            </td>
            <td class="text-end td-col-3 fw-bold border-0">
              @if (item.closingBalance !== null) {
              {{ item.closingBalance | number }}
              } @else {
              -
              }
            </td>
          </tr>
          }
          }
          @if (stockmovementList.length === 0) {
          <tr>
            <td colspan="5" class="text-center py-4 border-0">
              <p class="text-muted mb-0 small fw-bold">No purchase data found.</p>
            </td>
          </tr>
          }
        </tbody>
      </table>

      @if (scroolLoader) {
        <div class="d-flex justify-content-center py-3">
          <app-loader [loadingIcon]="scroolLoader"></app-loader>
        </div>
      }

      @if (endOfResults && stockmovementList.length > 0) {
        <div class="text-center py-3 text-muted small">
          End of results.
        </div>
      }
    </div>
  </div>
</ng-template>